<template>
  <span>
    <span v-if=" !revealAnswers" class="clex-keyword"
      v-scroll-in-view-when="active"
      :style="style"
      v-bind:class="{active, answered}"
      v-on:click.prevent="select">{{visibleContent}}</span>

    <span v-else
      class="clex-keyword answer"
      :style="style"
      v-bind:class="{correct: answerIsCorrect, wrong: !answerIsCorrect}"
      v-html="answerDiff"></span>
  </span>

</template>

<script>

import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
export default {

  props: ['keywordId', 'scale'],

  methods: {
    select() {
      this.$store.dispatch('studier/setActiveKeyword', {keyword: this.keyword})
    },
  },


  computed: {
    ...mapGetters({
      revealAnswers: 'studier/microNoteIsCompleted',
      chapter: 'studier/chapter',
    }),

    // Using it's ID, it looks itself up in the store and watches for changes
    keyword() {
      return this.$store.state.studier.keywords[this.keywordId]
    },

    style() {
      const style = {
        left:     this.keyword.x,
        top:      this.keyword.y,
        width:    this.keyword.width,
        height:   this.keyword.height,
        lineHeight: this.keyword.height,
      }
      // Scale the styles
      for(let prop in style) style[prop] = `${style[prop] * this.scale}px`;

      return style;
    },



    // Determines what is displayed in the keyword
    visibleContent() {
      if (this.answer) { return this.answer; }

      let a = '';
      if (!this.chapter || !this.chapter.KeywordDifficulty || this.chapter.KeywordDifficulty == 1) {
        for (let char of this.realAnswer) {
          a += char === ' ' ? ' ' : '*';
        }
      } else if (this.chapter.KeywordDifficulty == 2) {
        a = "----- ".repeat(this.realAnswer.split(' ').length).trim();
      } else {
        a = " ? ";
      }
      return a;
    },

    // Highlights errors in red, including misspelling
    answerDiff() {
      if( !this.answer || !this.realAnswer) return '';
      const answer = this.answer.trim().toLowerCase();
      const realAnswer = this.realAnswer.trim().toLowerCase();

      if(answer === realAnswer) return `<span>${this.answer}</span>`;
      let html = '';

      let answerArr = answer.split('');
      let realAnswerArr = realAnswer.trim().split('');

      // console.log(realAnswerArr);

      while(realAnswerArr.length || answerArr.length) {
        const x = answerArr.shift() || '';
        const y = realAnswerArr.shift() || '';
        const char = y || x;

        if(x === y) {
          html = html + char;
        } else {
          html = html + `<span class="mistake">${char}</span>`;
        }
      }
      // console.log(`html= ${html}`);
      return html;
    },

    answerIsCorrect() {
      return this.keyword ? this.keyword.correct : false;
    },

    // Whether or not the answer has been "submitted" for this keyword
    // ie. if user is in middle of typing it is technically not answered yet
    answered() {
      // console.log(this.keyword.answered)
      return this.keyword ? this.keyword.answered : false;
    },

    answer() {
      return this.keyword ? this.keyword.answer : null;
    },

    realAnswer() {
      return this.keyword ? this.keyword.realAnswer : null;
    },

    placeholder() {
      return this.keyword ? this.keyword.placeholder : null;
    },

    active() {
      if(this.keywordId === this.$store.state.studier.currentKeywordUID) {
        return true;
      } else {
        return false;
      }
    },

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.clex-keyword {
  // background: #fcd45e;
  background: orange;
  // padding: 3px 5px;
  padding: 0;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;

  position: absolute;
  z-index: 10;
  border: 1px solid black;
  box-sizing: content-box; /* ** this is very important to make position calcs work ** */

  text-align: center;
  overflow: hidden;

  &.answer {
    background: white;
    color: #4285f4;
  }

  .mistake {
    color: red;
  }

  &.answer.correct {
    color: #37b358;
    /*color: white;*/
  }

  &.answered {
    // background: orange;
    background: #fcd45e;
  }

  &.active {
    background: #37b358;
    /*background: #4285f4;*/
    color: white;

    z-index: 100;
    -webkit-box-shadow: -1px 0px 25px -3px rgba(0,0,0,0.54);
    -moz-box-shadow: -1px 0px 25px -3px rgba(0,0,0,0.54);
    box-shadow: -1px 0px 25px -3px rgba(0,0,0,0.54);
  }
}









</style>



// WEBPACK FOOTER //
// ImageKeyword.vue?7808da68